import { Injectable } from '@angular/core';
import { AuthenticationService, User } from '@kv-common-components/kx-services';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import { I18nPipe } from '../pipes/i18n.pipe';

@Injectable({
    providedIn: 'root',
})
export class PersonneHelperService {
    constructor(
        private i18nPipe: I18nPipe,
        private authenticationService: AuthenticationService
    ) {}

    getCivilite(codeCivilite: string) {
        return codeCivilite === 'mister'
            ? this.i18nPipe.transform('global.form.civilityMister')
            : this.i18nPipe.transform('global.form.civilityMadam');
    }
    initCurrentUser(espaceClient: any, user: User) {
        if (
            espaceClient.listeProjetsCredits &&
            espaceClient.listeProjetsCredits.length > 0
        ) {
            // by default we take the first project in the list since there is no idDossier in localStroage
            let dossier = espaceClient.listeProjetsCredits[0];
            if (user.idDossier) {
                dossier = espaceClient.listeProjetsCredits.find(
                    (projetCredit) =>
                        projetCredit.idProjetCredit === user.idDossier
                );
            }
            const contextDossier = new ContextDossier();
            contextDossier.dossier = dossier;
            contextDossier.emprunteur = dossier.listeEmprunteurs.find(
                (itv) => itv.idPersonne === user.idPersonne
            );
            user.idDossier = contextDossier.dossier.idProjetCredit;
            user.idPropositionPrincipale =
                contextDossier.emprunteur.assurance?.idPropositionPrincipale;
            this.authenticationService.updateCurrentUser(user);
        }
    }
}
